/**
 * @fileoverview Menu dropdown Preact component.
 * Renders the hamburger menu contents: mute button and navigation items.
 * Navigation is handled internally via window.__appNavigate.
 * The mute button retains its id so ToddlerGame can wire up its click handler.
 */

import { render } from 'preact';
import { tapProps } from '../utilities/tapProps.js';
import { menuStrings } from '../i18n/menu.js';
import { showLanguageModal } from './LanguageModal.js';

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

function MenuDropdown() {
    const navigate = (path: string) => (window as any).__appNavigate?.(path);
    const openLanguageModal = () => {
        document.getElementById('menuDropdown')?.classList.remove('show');
        showLanguageModal();
    };

    return (
        <>
            <button id="muteButton" class="menu-item" aria-label="Toggle mute">
                <span class="material-icons menu-icon">music_note</span>
                <span class="menu-label">{menuStrings.sound}</span>
            </button>
            {/* Premium unlock buttons — uncomment when premium is re-enabled */}
            <button id="unlockButton" class="menu-item">
                <span class="menu-emoji">🔓</span>
                <span class="menu-label">{menuStrings.buyThemes}</span>
            </button>
            <button id="restorePurchase" class="menu-item">
                <span class="menu-emoji">🔑</span>
                <span class="menu-label">{menuStrings.restorePurchase}</span>
            </button>
            <button id="faqButton" class="menu-item" {...tapProps(() => navigate('/faq'))}>
                <span class="menu-emoji">💬</span>
                <span class="menu-label">{menuStrings.faq}</span>
            </button>
            <button id="storiesButton" class="menu-item" {...tapProps(() => navigate('/stories'))}>
                <span class="menu-emoji">📖</span>
                <span class="menu-label">{menuStrings.stories}</span>
            </button>
            <button id="changeLanguageButton" class="menu-item" {...tapProps(openLanguageModal)}>
                <span class="menu-emoji">🌐</span>
                <span class="menu-label">{menuStrings.language}</span>
            </button>
        </>
    );
}

// ---------------------------------------------------------------------------
// Mount helper
// ---------------------------------------------------------------------------

/** Renders the MenuDropdown component into the #menuDropdown element. */
export function mountMenuDropdown(): void {
    const el = document.getElementById('menuDropdown');
    if (!el) return;
    render(<MenuDropdown />, el);
}
